import type { RuleDefinition } from '../domain/types';
import { finding, isCellBlank } from './helpers';

export const BQ001: RuleDefinition = {
  id: 'BQ001',
  name: '项目名称缺失',
  description: '检查清单明细行是否缺少项目名称。',
  defaultSeverity: 'error',
  enabled: true,
  applicableFields: ['name'],
  message: '明细行的项目名称为空。',
  suggestion: '请回到原计价文件补充或确认项目名称。',
  check: ({ detailRows }) =>
    detailRows.filter((row) => isCellBlank(row, 'name')).map((row) => finding(row, 'name')),
};
